export default __webpack_public_path__ + "static/media/inspection.43069da6.svg";